import { CheckOutlined, DownloadOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { Link, useRouteError } from 'react-router-dom'
import { toast } from 'sonner'

import cn from './Error.module.scss'

interface RouteErrorLike {
  statusText?: string
  message?: string
  stack?: string
  response?: { data?: unknown }
}

function Error({ title }: { title: string }) {
  const error = useRouteError() as RouteErrorLike | null | undefined
  const [downloaded, setDownloaded] = useState(false)

  let errorDetails = ''
  if (error) {
    errorDetails += `=== PIPS Error Log ===\n`
    errorDetails += `Date: ${new Date().toLocaleString('ru-RU')}\n`
    errorDetails += `URL: ${window.location.href}\n`
    errorDetails += `User-Agent: ${navigator.userAgent}\n`
    errorDetails += `======================\n\n`

    if (error.statusText || error.message) {
      errorDetails += `Message: ${error.statusText || error.message}\n\n`
    }
    if (error.stack) {
      errorDetails += `Stack trace:\n${error.stack}\n\n`
    }
    if (error.response?.data) {
      errorDetails += `API Response:\n${JSON.stringify(error.response.data, null, 2)}\n`
    }
    if (
      !errorDetails ||
      errorDetails ===
        `=== PIPS Error Log ===\nDate: ${new Date().toLocaleString('ru-RU')}\nURL: ${window.location.href}\nUser-Agent: ${navigator.userAgent}\n======================\n\n`
    ) {
      try {
        errorDetails += JSON.stringify(error, null, 2)
      } catch (e) {
        errorDetails += String(error)
      }
    }
  }

  const handleDownload = () => {
    if (!errorDetails) return

    try {
      const blob = new Blob([errorDetails], {
        type: 'text/plain;charset=utf-8',
      })

      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      const timestamp = new Date()
        .toISOString()
        .replace(/[:.]/g, '-')
        .replace('T', '_')
        .slice(0, 19)
      link.download = `pips_error_log_${timestamp}.txt`

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      setDownloaded(true)
      toast.success('Лог ошибки успешно скачан')

      setTimeout(() => setDownloaded(false), 3000)
    } catch (err) {
      console.error('Ошибка при скачивании файла:', err)
      toast.error('Не удалось скачать файл')
    }
  }

  return (
    <section className={cn.error}>
      <div className={cn.inner}>
        <p className={cn.title}>{title}</p>

        <Link to="/">
          <button className={cn.mainBtn}>Вернуться на главную</button>
        </Link>

        {errorDetails && (
          <div className={cn.errorLogContainer}>
            <div className={cn.errorLogHeader}>
              <span>Технические подробности для поддержки:</span>
              <button
                onClick={handleDownload}
                className={cn.copyBtn}
                title="Скачать лог ошибки в формате .txt"
              >
                {downloaded ? (
                  <CheckOutlined className={cn.downloadedIcon} />
                ) : (
                  <DownloadOutlined />
                )}
                {downloaded ? 'Скачано' : 'Скачать .txt'}
              </button>
            </div>
            <pre className={cn.errorLogContent}>{errorDetails}</pre>
          </div>
        )}
      </div>
    </section>
  )
}

export default Error
